<sim-basic-material-dialog
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-glass-cheers', fontSet: 'fad'}"
	[headerText]="T.SESSION_COMPLETE_DIALOG_HEADER | translate"
	[matDialogData]="data"
	[rect]="rect"
	[showClosingX]="false"
>
	<ng-container dialogContent>
		<div class="contentContainer {{ SimStatusPalette.success }}">
			<label class="headingLabel">{{ T.SESSION_COMPLETE_DIALOG_CONGRATULATIONS | translate }}</label>
			<mat-icon [fontIcon]="content().fontIcon" color="accent" fontSet="fad" inline />
			<label [innerHTML]="content().paragraph | translate: {sessionTitle: title()}" class="secondary"></label>
		</div>
	</ng-container>
	<ng-container actions>
		<sim-button (onClick)="closeDialog()" [icon]="{fontIcon: 'fa-door-open', fontSet: 'fad'}" [label]="T.BUTTON_CLOSE" />
	</ng-container>
</sim-basic-material-dialog>
